import { CriterionService } from './criterion.service'
import { Criterion } from './criterion'
import { DbRecord } from './db-record'

export class CriterionItem {
  _regexp: RegExp
  _weight: number = 1

  constructor(
    public cs: CriterionService,
    public criterion: Criterion,
    public id: string,
    regexpTxt: string,
    weight: any
  ) {
    this.regexp = regexpTxt
    this.weight = weight
    this.criterion.itemsSet.add(this)
  }

  get seed() {
    return [this.regexp, this.weight]
  }

  delete() {
    this.criterion.itemsSet.delete(this)
  }

  run(dbr: DbRecord): number {
    if (this._regexp.test(dbr.criterionTitle)) {
      this.criterion.addMatch(dbr,this)
      return 1.000001 * this._weight
    }
    let abs = dbr.criterionAbstract
    if (abs && this._regexp.test(abs)) {
        this.criterion.addMatch(dbr,this)
      return this._weight
    }
    return 0
  }

  set regexp(txt: string) {
    if (txt)
      this._regexp = new RegExp(txt,'i')
  }

  get regexp() {
    if (!this._regexp)
      return ''
    return this._regexp.source
  }

  set weight(txt: any) {
    this._weight = parseFloat(txt)
  }

  get weight() {
    return this._weight.toString()
  }

}



// WEBPACK FOOTER //
// ./src/app/criterion-item.ts